import React from 'react'

import { styled } from '@mui/material'

const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.text.primary,
    textDecoration: 'underline',
  },
  '&:visited': {
    color: theme.palette.text.primary,
  },
}))

const Link = ({ children, href }) => (
  <StyledLink href={href}>{children}</StyledLink>
)

export default Link
